export default
{
    props:
    {
        url: { type: String, default: '' },
        alt: { type: String, default: '' },
        content: { type: Object, default: null },
        isInViewport: { type: Boolean, default: false }
    },

    watch:
    {
        isInViewport: 'onObserve'
    },

    methods:
    {
        onObserve()
        {
            if(this.isInViewport && !this._isLoading)
            {
                this.onLoad()
            }
        },

        onLoad()
        {
            this._isLoading = true

            const img = new Image()

            img.onload = (() =>
            {
                this.$el.src = img.src

                // add timer to fix instagram image display issue
                const timer = this.content.post_type === 'instagram' ? 50 : 0

                setTimeout(() => {
                    this.$emit('loaded')
                    this.$el.classList.add('is-loaded')
                }, timer)
            })

            img.src = this.url
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/core-lazy-load/script.js